'use strict';

function DashboardPreapproval() {
  this.id = null;
  this.node = null;
  this.$node = null;
  this.declaredClass = null;
  this.extends = [_MoneyController, _ErrorController, _ResponsiveLayout, _Paths];
  this._analytics = new Analytics();
  this.loanStateRoutingEnabled = true;
  this._path = window.location.pathname;

  this._DEBUG = false;

  this.init = function () {
    this._super();

    this._portalPresenter = document.getElementById('Portal').mogo();

    // user must view interstitial content once before viewing this page
    var MEMBER_CONTENTS_KEY = 'money-interstitial';
    var isCreditSeeker = this._session.getSessionCookie('is_credit_seeker') === 'true';
    if (!isCreditSeeker && !this._productSettings.hasViewedContent(MEMBER_CONTENTS_KEY)) {
      this.aborting = true;
      this.history.replaceUrl(Product.shortcutMappings[MEMBER_CONTENTS_KEY]);
    } else {
      this.$node = $(this.node);
      this._$feedbackDialog = this.$node.find('.js--feedback-dialog');

      this.analytics.forcePushEvent('virtual-page-view');

      this.initDecisionPendingState();
    }
  };

  this.initAllReady = function () {
    if (!this.aborting) {
      this._super();
    }
  };

  this.initDecisionPendingState = function () {
    if (this.isPendingLoanOfferDecision()) {
      this.analytics.pushEvent('trust-science');
      this.presenter.scanDOM('#main-nav'); // Show most recent Nav state while pending
    }
  };

  this.initPage = function () {
    if (this.aborting) return;
    if (this._DEBUG) console.log('10. DashboardPreapproval initPage.');

    this._checkForNotifications();
    // exception case for 'mobile only' page that shares this page component:
    // '/member/dashboard/loans/request'
    if (this._getCurrentUrl() === '/member/dashboard/loans/request') {
      this.loanStateRoutingEnabled = false;
    }
    var displayedOffer = this._isEligibleForLoanProduct() ? this.presenter.models.money.displayed_offer[0] : null;
    var wrapperClass = 'is-';
    if (displayedOffer) {
      wrapperClass += displayedOffer.name;
      if (displayedOffer.offer_type === 'enhanced') {
        wrapperClass += '-enhanced';
      }
    }
    this.$node.addClass(wrapperClass);

    // legacy things:
    this._addComputedVariables();
    this._fsButtons();
    this._fsLinkGuard();
    this._setupCreditSeekerStatus();
    this._displayGetMoneySteps();
    this._setupDeclinedState();
    this._setupProductSwitcher();
    this._setupOffersFeedback();
    this._legalDisclaimer();
    this.$node.find('.ui-state').removeClass('ui-state__loading').addClass('ui-state__loaded');
    this._pushPageAnalytics();

    if (displayedOffer && displayedOffer.name === 'lendful') {
      this._setupLendfulCta();
    }

    // Guard to prevent duplication on dashboard home
    if (this._path !== this.paths.account.dashboard) {
      this._setupLivechat();
    }
    // picture element fix for injected html
    if (typeof picturefill === 'function') {
      picturefill();
    }

    this._debugDetails();

    // Required when route has defer_page_load_completed: true
    this._portalPresenter.setPageLoadComplete();
  };

  this._pushPageAnalytics = function () {
    this.analytics.forcePushEvent('virtual-page-view');
    this.analytics.forcePushEvent('mogo-money-status', null, this);
  };

  this._setupProductSwitcher = function () {
    $('.js--product-switcher').mogo().create('ProductSwitcher', {
      presenter: this.presenter
    });
  };

  // Reup-preapproval Notification:
  this._checkForNotifications = function () {
    var notification = getURLParameter('notification').trim();
    var offerStatus = this._getOfferStatus();
    if (notification == 'reup-preapproval' && offerStatus !== 'declined') {
      $('#Notification').mogo().create({
        type: 'success',
        msg: 'You did it! Congrats on your pre-approval.',
        isPersistent: false
      });
      this._analytics.pushEvent(notification);
    }
  };

  /* ~~~ Credit Seeker Status update ~~~ */

  this._setupCreditSeekerStatus = function () {
    this._$revealOfferCta = $(this.node).find('.js--reveal-offer-cta');
    this._$revealOfferCta.click(this._updateCreditSeekerStatus.bind(this));
  };

  this._updateCreditSeekerStatus = function (e) {
    e.preventDefault();
    this._$revealOfferCta.mogo().setDisabledLoadState();
    if (this.presenter.hasAction('account.edit_member')) {
      this.presenter.performAction('account.edit_member', { credit_seeker_status: 'warm_lead' }, this._onUpdateCreditSeekerStatus.bind(this));
    }
  };

  this._onUpdateCreditSeekerStatus = function (data, response) {
    var _this = this;

    if (this.isGeneralConnectionIssue(data, response)) {
      this.invokeConnectionIssuePage({
        action: 'account.edit_member',
        productLabel: 'MogoMember'
      });
    } else if (response === 200) {
      // force half second delay to simulate Mogo working hard to get the user a great offer.
      setTimeout(function () {
        _this._$revealOfferCta.mogo().removeDisabledLoadState();
        _this.presenter.updateModel('account', data);
        _this._pushPageAnalytics();
        // redraw disclaimers
        var legalDisclaimerEl = document.getElementsByClassName('js--legal-disclaimer');
        if (legalDisclaimerEl[0] && legalDisclaimerEl[0].mogo && legalDisclaimerEl[0].mogo().redraw) {
          legalDisclaimerEl[0].mogo().redraw();
        }
      }, 500);
    } else if (data.errors) {
      this.analytics.forcePushEvent('generic-api-response-error', {
        event: ['EditMemberResponseError'],
        Code: [errorData.errors[0].code],
        Key: [errorData.errors[0].key],
        Msg: [errorData.errors[0].msg],
        Property: [errorData.errors[0].property]
      });
    }
  };

  /* ~~~ Common Page UI ~~~ */

  this._setupOffersFeedback = function () {
    this._onSubmitFeedbackCallback = this.presenter.addCallbackToAction('money.offers.create_offer_feedback', this._onSubmitFeedback.bind(this));
    this.presenter.updateDOM();

    if (this.presenter.hasAction('money.offers.create_offer_feedback')) {
      // Create Feedback Dialog, pass in presenter
      this._$feedbackDialog.mogo().create('FeedbackDialog', {
        presenter: this.presenter
      });
    }

    if (!this.hasFeedbackBeenSubmitted() && this.presenter.hasAction('money.offers.create_offer_feedback')) {
      this.analytics.pushEvent('loan-offer-feedback-state', { FeedbackState: ['Active'] });
    } else if (this.hasFeedbackBeenSubmitted()) {
      this.analytics.pushEvent('loan-offer-feedback-state', {
        FeedbackState: ['Already submitted']
      });
    }
  };

  this.hasFeedbackBeenSubmitted = function () {
    var offerData = this._activeOffer.getOfferData();
    return !!(offerData ? offerData.feedback_provided_at : offerData);
  };

  this._onSubmitFeedback = function () {
    this.presenter.updateModel('money.offers');
  };

  this._addComputedVariables = function () {
    var _this2 = this;

    this.presenter.addComputedVariable('hasFeedbackBeenSubmitted', ['money.offers.offers'], function () {
      return _this2.hasFeedbackBeenSubmitted();
    });
    this.presenter.addComputedVariable('formattedCreditCheckExpiryDate', ['account.credit_check_decision_expires_at'], function (date) {
      return moment(date).format('MMMM DD, YYYY');
    });
    this.presenter.addComputedVariable('isSoftDeclineExpired', ['account.credit_check_decision_expires_at', 'account.credit_check_decision'], function () {
      return _this2.isSoftDeclineExpired();
    });
  };

  this._setupLivechat = function () {
    // Behavior: Create LiveChat if it's not created
    // Chat should be maximized if chat is 1) already maximized 2)visitor is engaged in convo
    this._liveChat = this.$node.find('.js--live-chat');
    this._liveChatComponent = $("[data-mogo-UI='LiveChat']");

    if (this._liveChat.length && !this._liveChatComponent.length) {
      this._liveChat.mogo().create('LiveChat', { presenter: this.presenter });
    } else if (this._liveChatComponent.length && this._liveChatComponent.mogo().declaredClass) {
      this._liveChatComponent.mogo().minimizeChatOnPage();
      this._liveChat = this._liveChatComponent;
    }
  };

  // Button Loading states:
  this._fsButtons = function () {
    // any buttons clicked should be switched to loading state
    $(this.node).find('.js--fs-button').click(function () {
      $(this).mogo().setLoadState();
    });

    $(window).on('pageshow.fs-buttons', function (ev) {
      // specifically for safari back-forward cache
      if (ev.originalEvent.persisted) {
        // find all loading buttons and remove loading state
        $("a[data-mogo-ui='Button'].button-loading").mogo().removeLoadState();
      }
    });
  };

  this._fsLinkGuard = function () {
    var _this3 = this;

    var fsLinks = document.querySelectorAll('.js--fs-link-guard');
    var fsBoundLinks = document.querySelectorAll('.js--fs-link-guard-pv');

    fsLinks.forEach(function (link) {
      return link.addEventListener('click', _this3._onClickFSLink.bind(_this3), true);
    });
    fsBoundLinks.forEach(function (link) {
      return link.addEventListener('click', _this3._onClickFSLink.bind(_this3, true), true);
    });
  };

  this._onClickFSLink = function (hasDataHistory, e) {
    var _this4 = this;

    e.stopImmediatePropagation();
    e.preventDefault();
    var linkUrl = e.target.href;
    // history clicks need to be blocked (nope)
    // e.target.setAttribute('data-history-disabled', true);

    this.doubleCheckApplicationState(function () {
      // passedCheckCallback fired if users passes the double check
      if (hasDataHistory) {
        // hasDataHistory is for links that stay within SOA and have with data-history=true
        // e.target.setAttribute('data-history-disabled', false);
        _this4.history.goToUrl(linkUrl);
      } else {
        location.replace(linkUrl);
      }
    }, function () {
      // failedCheckCallback fired if users does NOT pass the double check
      console.log('doubleCheckApplicationState: failedCheckCallback');
      try {
        FS.event('Mogo App Debug', {
          name: 'Applications double check',
          details: 'Failed double check application state',
          OfferStatus: _this4._getOfferStatus(),
          OfferName: _this4._activeOffer.getOfferName(),
          applications: _this4.presenter.getModelProperty('money.applications')
        });
      } catch (e) {}
      $('#Notification').mogo().create({
        type: 'error',
        isPersistent: false
      });
      _this4.history.goToUrl(_this4.paths.account.dashboard);
    });

    return false;
  };

  this.doubleCheckApplicationState = function (passedCheckCallback, failedCheckCallback) {
    // Call endpoint and see if create_applications relink is returned
    // and check if active liquid loan exists
    this._onCheckApplicationsCallback = this.presenter.addCallbackToAction('money.applications.self', this.doubleCheckApplicationState2.bind(this, passedCheckCallback, failedCheckCallback));

    this.presenter.performAction('money.applications.self');
  };

  this.doubleCheckApplicationState2 = function (passedCheckCallback, failedCheckCallback, data, response) {
    var _this5 = this;

    this.presenter.removeCallbackFromAction('money.applications.self', this._onCheckApplicationsCallback);
    var _noRedFlags = true;

    if (response == 200) {
      if (!this.presenter.models.money.applications) {
        this.presenter.createModel('money.applications', { data: data });
      } else {
        this.presenter.updateModel('money.applications', data);
      }

      data.links.forEach(function (obj) {
        if (obj.rel === 'create_loan_application' && _this5._activeOffer.getOfferData() && _this5._activeOffer.getOfferName() === 'liquid') {
          _noRedFlags = false;
        }
      });
    }

    if (_noRedFlags) {
      passedCheckCallback();
    } else {
      failedCheckCallback();
    }
  };

  /* ~~~ Specific Sections UI ~~~ */

  // Get Money Steps:
  this._displayGetMoneySteps = function () {
    if (this._isEligibleForLoanProduct()) {
      this._GettingMogoMoney.setup();
    }
  };

  // Getting MogoMoney Steps:
  this._GettingMogoMoney = {
    _section1Class: '.js--section1',
    _section2Class: '.js--section2',
    _fwdButtonClass: '.processBtn',
    _backButtonClass: '.psuedoBack',

    setup: function () {
      this._$section1 = this.$node.find(this._GettingMogoMoney._section1Class);
      this._$section2 = this.$node.find(this._GettingMogoMoney._section2Class);
      this._fwdButton1El = this.$node.find(this._GettingMogoMoney._fwdButtonClass);
      this._backButton2El = this.$node.find(this._GettingMogoMoney._backButtonClass);

      this._fwdButton1El.on('click', this._GettingMogoMoney.showProgressSteps.bind(this));
      this._backButton2El.on('click', this._GettingMogoMoney.hideProgressSteps.bind(this));
    }.bind(this),

    showProgressSteps: function showProgressSteps() {
      this._$section1.hide();
      this._$section2.show();
      this._GettingMogoMoney._scrollToTop();
      this.analytics.pushEvent('virtual-page-view', {
        Page: ['/member/dashboard/loans/progress-steps']
      });
    },
    hideProgressSteps: function hideProgressSteps() {
      this._GettingMogoMoney._restoreDefaultView();
      this._GettingMogoMoney._scrollToTop();
      this.analytics.pushEvent('virtual-page-view');
    },


    _restoreDefaultView: function () {
      this._$section1.css('display', '');
      this._$section2.css('display', '');
    }.bind(this),

    _scrollToTop: function _scrollToTop() {
      $('html, body').animate({ scrollTop: 0 }, 'slow');
    }
  };

  /* ~~~ Specific State Adjustments ~~~ */

  // Declined State:
  this._setupDeclinedState = function () {
    // Force user to toggle a single item that is closed by default.
    if (!this._isEligibleForLoanProduct()) {
      this._declinedDecisionIcon = this.$node.find('.dashboard-money__declined__expand-icon');
      this._declinedDecisionDetails = this.$node.find('.dashboard-money__declined__mogo-decision-description');
      this.$node.find('.dashboard-money__declined__mogo-decision__head').on('click', this._toggleMogoDecisionDetails.bind(this));
    }
  };

  // Declined State accordian:
  this._toggleMogoDecisionDetails = function (event) {
    this._declinedDecisionIcon = $(event.target.getElementsByClassName('dashboard-money__declined__expand-icon'));
    this._declinedDecisionDetails = $(event.target.parentElement).nextAll('.dashboard-money__declined__mogo-decision-description:first');
    if (this._declinedDecisionIcon.hasClass('expanded')) {
      this._declinedDecisionIcon.removeClass('expanded');
      this._declinedDecisionDetails.slideUp();
    } else {
      this._declinedDecisionIcon.addClass('expanded');
      this._declinedDecisionDetails.slideDown();
    }
  };

  /* ~~~ Common Page Additions ~~~ */

  // Legal Disclaimer:
  this._legalDisclaimer = function () {
    var ready = this._checkForCompletedCardDataView();
    if (!ready) {
      setTimeout(this._legalDisclaimer.bind(this), 200);
      return false;
    }
    var legal = $('.js--legal-disclaimer', this.node);
    if (legal.length) {
      legal.mogo().create('LegalDisclaimer', {
        legal: $('[data-legal]:visible', this.node),
        presenter: this.presenter
      });
    } else {
      console.error('DashboardMoney.js: Missing .js--legal-disclaimer element on page.');
    }
  };

  // @TODO Hackery to fire some JS after a data-view has been loaded.
  // should be replaced with a feature to do this within the platform
  this._checkForCompletedCardDataView = function () {
    var flag = void 0;
    var card = $('.js--product-switcher').find('.product-card__group');
    $.each(card, function () {
      if ($(this).attr('data-view-state') === 'shown') {
        flag = true;
      }
    });
    return flag;
  };

  this._setupLendfulCta = function () {
    var _this6 = this;

    var ctaElement = document.querySelector('.js--get-referral-cta');
    ctaElement.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      _this6._onLendfulClick();
    });
  };

  this._onLendfulClick = function () {
    var _url = this.presenter.getModelProperty('money.offers.referral.referrer_url');

    // Analytics
    var analyticsData = this.analytics.constructData('Lendful');
    var analyticsRequest = new APIRequest('/analytics', 'POST', analyticsData, null);
    analyticsRequest.send();

    window.open(_url, null);
  };

  // Livechat: (TODO)

  this.destroy = function () {
    this._super();
    if (this.aborting) return;

    $(window).off('pageshow.fs-buttons');
    this.presenter.removeComputedVariable('hasFeedbackBeenSubmitted');
    this.presenter.removeComputedVariable('formattedCreditCheckExpiryDate');
    this.presenter.removeComputedVariable('isSoftDeclineExpired');

    if (this._onCheckApplicationsCallback) {
      this.presenter.removeCallbackFromAction('money.applications.self', this._onCheckApplicationsCallback);
    }

    if (!this._$feedbackDialog.mogo().create) {
      this._$feedbackDialog.mogo().destroy();
    }

    // LiveChat:
    var isLoansPage = window.location.href.indexOf('money') !== -1;
    // Note: components get destroyed on view switch on some places (tray),
    // which is why sometimes mogo() of undefined error comes up.
    if (!isLoansPage && this._liveChat) {
      if (this._liveChat.mogo() && this._liveChat.mogo().declaredClass && this._liveChat.mogo().clear) {
        this._liveChat.mogo().clear();
      }
    }
  };
}